module.exports = __webpack_public_path__ + "img/img-item-b.0db1649a.png";